import { entity } from "./Connection"

export const UserEntity = entity("User");
